import { __awaiter, __generator } from "tslib";
import { odataUrlFrom } from "../odata.js";
import { extractWebUrl } from "../utils/extractweburl.js";
import { Web } from "../webs/types.js";
import "../lists/web.js";
import { _Folder, Folder } from "../folders/types.js";
_Folder.prototype.getDefaultColumnValues = function () {
    return __awaiter(this, void 0, void 0, function () {
        var folderProps, serRelPath, web, docLib;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Folder(this, "Properties").select("vti_x005f_listname")()];
                case 1:
                    folderProps = _a.sent();
                    return [4 /*yield*/, this.select("ServerRelativePath")()];
                case 2:
                    serRelPath = (_a.sent()).ServerRelativePath;
                    web = Web(extractWebUrl(odataUrlFrom(folderProps))).configureFrom(this);
                    docLib = web.lists.getById(folderProps.vti_x005f_listname);
                    return [4 /*yield*/, docLib.getDefaultColumnValues()];
                case 3: 
                // and we return the defaults associated with this folder's server relative path only
                // if you want all the defaults use list.getDefaultColumnValues()
                return [2 /*return*/, (_a.sent()).filter(function (v) { return v.path.toLowerCase() === serRelPath.DecodedUrl.toLowerCase(); })];
            }
        });
    });
};
_Folder.prototype.setDefaultColumnValues = function (fieldDefaults, merge) {
    if (merge === void 0) { merge = true; }
    return __awaiter(this, void 0, void 0, function () {
        var folderProps, web, docLib, folderPath, existingDefaults, filteredExistingDefaults;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Folder(this, "Properties").select("vti_x005f_listname")()];
                case 1:
                    folderProps = _a.sent();
                    web = Web(extractWebUrl(odataUrlFrom(folderProps))).configureFrom(this);
                    docLib = web.lists.getById(folderProps.vti_x005f_listname);
                    return [4 /*yield*/, this.select("ServerRelativePath")()];
                case 2:
                    folderPath = (_a.sent()).ServerRelativePath.DecodedUrl;
                    return [4 /*yield*/, docLib.getDefaultColumnValues()];
                case 3:
                    existingDefaults = _a.sent();
                    filteredExistingDefaults = merge ? existingDefaults : existingDefaults.filter(function (f) { return f.path !== folderPath; });
                    // we update / add any new defaults from those passed to this method
                    fieldDefaults.forEach(function (d) {
                        var existing = filteredExistingDefaults.find(function (ed) { return ed.name === d.name && ed.path === folderPath; });
                        if (existing) {
                            existing.value = d.value;
                        }
                        else {
                            filteredExistingDefaults.push({
                                name: d.name,
                                path: folderPath,
                                value: d.value,
                            });
                        }
                    });
                    // after this operation filteredExistingDefaults should contain all the value we want to write to the file
                    return [4 /*yield*/, docLib.setDefaultColumnValues(filteredExistingDefaults)];
                case 4:
                    // after this operation filteredExistingDefaults should contain all the value we want to write to the file
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
_Folder.prototype.clearDefaultColumnValues = function () {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.setDefaultColumnValues([], false)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=folder.js.map